import { Observable, from, of } from 'rxjs';
import { catchError, switchMap, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import {
  BillingAction,
  BillingActions, RefreshSubscriptionStatus, RefreshSubscriptionStatusError, RefreshSubscriptionStatusSucceeded,
  SyncSubscriptionStatus,
  SyncSubscriptionStatusError, SyncSubscriptionStatusSucceeded,
} from '../actions/billing.action';
import OrganizationService from '../../shared/services/organization.service';
import { LoadOrgSubscriptionStatus } from '../actions/orgHierarchy.action';

const syncSubscriptionStatus = (action$: Observable<BillingAction>) => action$.pipe(
  ofType<SyncSubscriptionStatus>(BillingActions.SyncSubscriptionStatus),
  switchMap(({hostedPageId}) => from(OrganizationService.syncBillingSubscription(hostedPageId)).pipe(
    mergeMap(() => of(
      new SyncSubscriptionStatusSucceeded()
    )),
    catchError((error) => of(new SyncSubscriptionStatusError(error))),
  )),
);

const refreshSubscriptionStatus = (action$: Observable<BillingAction>) => action$.pipe(
  ofType<RefreshSubscriptionStatus>(BillingActions.RefreshSubscriptionStatus),
  switchMap(({subscriptionId, orgId}) => from(OrganizationService.refreshBillingSubscription(subscriptionId)
  ).pipe(
    mergeMap(() => of(
      new RefreshSubscriptionStatusSucceeded(),
      new LoadOrgSubscriptionStatus(orgId),
    )),
    catchError((error) => of(new RefreshSubscriptionStatusError(error))),
  )),
);

export default [
  syncSubscriptionStatus,
  refreshSubscriptionStatus,
];
